// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Autocomplete */
.autocomplete-wrapper {
  position: relative;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 180px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.autocomplete-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
}

.autocomplete-option:hover {
  background-color: #f0f4ff;
}

.autocomplete-empty {
  padding: 8px 12px;
  font-size: 13px;
  color: #888;
  list-style: none;
}

.platform-form-container {
  max-width: 600px;
  margin-top: 20px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group label .required {
  color: #d32f2f;
  margin-left: 4px;
}

.form-group .form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-group .form-control:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.form-group .form-control:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 30px;
}

.form-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.alert.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.alert.alert-success mat-icon {
  color: #28a745;
}

.alert.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.alert.alert-danger mat-icon {
  color: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/platformmaster/platform-master.component.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Autocomplete */\n.autocomplete-wrapper {\n  position: relative;\n}\n\n.autocomplete-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  max-height: 180px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n}\n\n.autocomplete-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.autocomplete-option:hover {\n  background-color: #f0f4ff;\n}\n\n.autocomplete-empty {\n  padding: 8px 12px;\n  font-size: 13px;\n  color: #888;\n  list-style: none;\n}\n\n.platform-form-container {\n  max-width: 600px;\n  margin-top: 20px;\n  padding: 30px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group label .required {\n  color: #d32f2f;\n  margin-left: 4px;\n}\n\n.form-group .form-control {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n}\n\n.form-group .form-control:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);\n}\n\n.form-group .form-control:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.form-actions button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border-radius: 4px;\n}\n\n.alert mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.alert.alert-success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.alert.alert-success mat-icon {\n  color: #28a745;\n}\n\n.alert.alert-danger {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.alert.alert-danger mat-icon {\n  color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
